/**
 * Path segments used in society public-search and registry URLs
 * (`/{org}/{segment}/...`). Centralised so the equality checks and URL builders
 * that route on these segments cannot silently drift apart.
 */
export const ROUTE_SEGMENT = {
  ANIMALS: 'animals',
  MEMBERS: 'members',
  SALES: 'sales',
  EXTERNAL: 'external',
  REGISTRY: 'registry',
  MATING: 'mating',
  DOWNLOADS: 'downloads',
  NOTES: 'notes',
  REGISTRATIONS: 'registrations',
} as const;
